let _ = require("ES/lib/lodash");
let dd = require("ES/lib/dd");
let esUtils = require("ES/utils/esUtils");
let DateRange = require("ES/widgets/DateRange");
let StagetimeModal = require("./StagetimeModal");
let Constants = require("../../../../../utils/Constants");

let timeOrBlakIfMidnight = function (d) {
  let time = esUtils.format_date(d, "h:MM TT");

  return time === "12:00 AM" ? "" : time;
};

let timeZoneDisplay = function (stagetime, venue) {
  let r = "local time";

  if (!_.isEmpty(_.get(venue, "timezone"))) {
    let r2 = _.find(_.get(Constants, "TIMEZONE_DATA", []), {"timezone": _.get(venue, "timezone")});
    r = _.get(r2, "abbreviation", _.get(venue, "timezone", ""));
  }
  return dd.span({className: "text-muted", style: {"marginLeft": "1rem"}}, r.toUpperCase());
};

let Stagetime = dd.createClass({
  render() {
    let {venues, stagetime, clickEdit} = this.props;

    let venue = null;
    _.each(venues, function (v) {
      if (v.id == stagetime.venueid) {
        venue = v;
      }
    });

    return dd.div({className: "Stagetime" + (clickEdit ? " clickable" : ""), onClick: clickEdit || null},
      clickEdit ? dd.span({className: "pull-right"},
        dd.a({href: "#", onClick: clickEdit}, dd.i({className: "fa fa-pencil"}), " Edit")
      ) : null,

      stagetime.description ? dd.div(null,
        stagetime.description
      ) : null,

      dd.div(null,
        dd.i({className: "fa fa-calendar text-muted"}),
        " ",
        DateRange({start: stagetime.starttime, start_format: "dddd, mmmm d, yyyy", stop: stagetime.stoptime, show_times: true}),
        timeZoneDisplay(stagetime, venue)
      ),

      venue ? dd.div(null,
        dd.i({className: "fa fa-map-marker text-muted"}), " " + esUtils.venue_to_string(venue)
      ) : null,

      dd.div(null,
        stagetime.room ? dd.span(null,
          dd.b({className: "text-muted"}, "Room"), " " + stagetime.room
        ) : null,
        " ",
        _.isDate(stagetime.avchecktime) ? dd.span(null,
          dd.b({className: "text-muted"}, "A/V check"), " " + esUtils.format_date(stagetime.avchecktime, "mm/d/yyyy"), " ", timeOrBlakIfMidnight(stagetime.avchecktime)
        ) : null
      )
    );
  }
});

module.exports = dd.createClass({
  getInitialState() {
    return {editing_stagetime_id: null};
  },
  __setEditingStagetime(id) {
    return _.bind(esUtils.wrapPreventDefault(function () {
      this.setState({editing_stagetime_id: id});
    }), this);
  },
  render() {
    let {event, Displaylists, read_only} = this.props;

    return dd.div({className: "Stagetimes"},
      dd.h4({className: "section-head"},
        "Stagetimes",
        read_only ? null : dd.button({className: "btn btn-default btn-sm pull-right", onClick: this.__setEditingStagetime(0)},
          dd.i({className: 'fa fa-plus'}), ' Add Stagetime'
        )
      ),
      dd.div({className: "clearfix"}),

      _.isEmpty(event.Stagetime) ? dd.div({className: "text-muted text-center"},
        dd.h4(null, "No Stagetimes"),
        "Use the button above to add a stagetime"
      ) : dd.div(null,
        _.map(event.Stagetime, function (stagetime) {
          return Stagetime({key: stagetime.id, stagetime: stagetime, venues: event.Venue, clickEdit: read_only ? null : this.__setEditingStagetime(stagetime.id)});
        }, this)
      ),

      this.state.editing_stagetime_id !== null ? StagetimeModal({
        event,
        Displaylists,
        stagetime_id: this.state.editing_stagetime_id,
        onClose: this.__setEditingStagetime(null)
      }) : null
    );
  }
});


// WEBPACK FOOTER //
// ./src/components/main_view/event_area/tabs/details/Stagetimes.js